module.exports = __webpack_public_path__ + "img/json-file.6c74cc5a.svg";